import {
  LOAD_NUMBEROFDAYSWORKED,
  LOAD_NUMBEROFDAYSWORKED_PREVIEW,
  LOAD_VEHICLE_NUMBEROFDAYSWORKED,
  LOAD_VEHICLE_TYPE_NUMBEROFDAYSWORKED,
} from './actions'

const initialState = {
  numberofdaysworkedoUrl: '',
  vehicleLists: [],
  vehicleTypeLists: [],
  numberofdaysworkedLoading: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_NUMBEROFDAYSWORKED.REQUEST:
    case LOAD_NUMBEROFDAYSWORKED_PREVIEW.REQUEST:
      const { loading } = action.payload
      return {
        ...state,
        numberofdaysworkedLoading: loading,
      }
    case LOAD_NUMBEROFDAYSWORKED.SUCCESS:
    case LOAD_NUMBEROFDAYSWORKED_PREVIEW.SUCCESS:
      return {
        ...state,
        numberofdaysworkedUrl: action.payload.data.data,
        numberofdaysworkedLoading: false,
      }
    case LOAD_VEHICLE_NUMBEROFDAYSWORKED.REQUEST:
      const { loading_vehicle } = action.payload
      return {
        ...state,
        numberofdaysworkedLoading: loading_vehicle,
      }
    case LOAD_VEHICLE_NUMBEROFDAYSWORKED.SUCCESS:
      return {
        ...state,
        vehicleLists: action.payload.data.data,
        numberofdaysworkedLoading: false,
      }
    case LOAD_VEHICLE_TYPE_NUMBEROFDAYSWORKED.SUCCESS:
      return {
        ...state,
        vehicleTypeLists: action.payload.data.data,
      }
    default:
      return state
  }
}
